import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './_react_setup_misc/serviceWorkerRegistration';
import reportWebVitals from './_react_setup_misc/reportWebVitals';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

const container = document.getElementById('root') as Element;

const root = ReactDOMClient.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Call the element loader after the app has been rendered the first time
defineCustomElements(window);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
